/* Michael – Brand-Experiences-Kontext. Beantwortet Fragen aus geprüften Einträgen, fragt passend nach,
   führt Schritt für Schritt durch eine Anfrage (Zusammenfassung → Absenden) und bestätigt die Speicherung nur,
   wenn der Server sie bestätigt. Keine erfundenen Termine, Zahlen oder Verfügbarkeiten. */
(function () {
  'use strict';
  function readJSON(id) { var el = document.getElementById(id); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  var CFG = readJSON('hybe-michael-config'), KB = readJSON('hybe-michael-kb');
  if (!CFG || !KB || document.getElementById('hybe-mi')) return;

  function H() { return window.HYBE || {}; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  /* ---------- UI ---------- */
  // E2E 08.10.: eigener Container direkt unter <body>. Innerhalb der Taiga-Abschnitte (transform) hing position:fixed am
  // Abschnitt – Knopf erschien erst am Seitenende, das Fenster war oben abgeschnitten (mobil −128 px, Desktop unter dem Header).
  var host = document.createElement('div');
  host.className = 'hybe hybe--portal';
  document.body.appendChild(host);
  var launch = document.createElement('button');
  launch.type = 'button'; launch.className = 'hybe-mi-launch'; launch.setAttribute('aria-haspopup', 'dialog'); launch.setAttribute('aria-controls', 'hybe-mi');
  launch.innerHTML = '<span class="hybe-mi-launch__dot" aria-hidden="true">M</span><span>Fragen? Michael hilft</span>';
  var panel = document.createElement('div');
  panel.id = 'hybe-mi'; panel.className = 'hybe-mi'; panel.hidden = true; panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-label', 'Chat mit Michael von HYRAYSE');
  panel.innerHTML =
    '<div class="hybe-mi__head"><span class="hybe-mi-launch__dot" aria-hidden="true">M</span><div><b>Michael</b><small>HYRAYSE Brand Experiences</small></div>' +
    '<button type="button" class="hybe-mi__close" aria-label="Chat schließen">×</button></div>' +
    '<div class="hybe-mi__log" aria-live="polite"></div>' +
    '<div class="hybe-mi__chips"></div>' +
    '<form class="hybe-mi__form"><label class="hybe-sr" for="hybe-mi-in">Nachricht an Michael</label><input id="hybe-mi-in" autocomplete="off" maxlength="600" placeholder="Schreib Michael …"><button type="submit" aria-label="Senden">➜</button></form>' +
    '<div class="hybe-mi__foot">Michael ist der digitale, KI-gestützte Assistent von HYRAYSE. Verbindliche Absprachen trifft unser Team. <a href="' + esc(CFG.privacy_url) + '" target="_blank" rel="noopener">Datenschutz</a></div>';
  host.appendChild(launch); host.appendChild(panel);
  var log = panel.querySelector('.hybe-mi__log'), chips = panel.querySelector('.hybe-mi__chips'),
      form = panel.querySelector('form'), input = panel.querySelector('input'), closeBtn = panel.querySelector('.hybe-mi__close');

  // Mobil: Startknopf ausblenden, solange Absende-Buttons im Bild sind (verdeckt sonst den Button)
  if ('IntersectionObserver' in window) {
    var visibleActions = 0;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { visibleActions += en.isIntersecting ? 1 : -1; });
      visibleActions = Math.max(0, visibleActions);
      launch.classList.toggle('is-tucked', visibleActions > 0 && window.innerWidth < 700);
    });
    Array.prototype.forEach.call(document.querySelectorAll('.hybe-form__actions, .hybe-cta .hybe__btns'), function (el) { io.observe(el); });
  }

  var started = false;
  function open() {
    panel.hidden = false; launch.hidden = true;
    if (!started) { started = true; bot(KB.greeting); showQuick(); H().track && H().track('brand_michael_opened', {}); }
    setTimeout(function () { input.focus(); }, 50);
  }
  function close() { panel.hidden = true; launch.hidden = false; launch.focus(); }
  launch.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  window.HYBE_MICHAEL = { open: open, close: close, ask: function (t) { open(); userSays(t); } };

  function add(cls, text) {
    var d = document.createElement('div'); d.className = 'hybe-mi__msg hybe-mi__msg--' + cls; d.textContent = text;
    log.appendChild(d); log.scrollTop = log.scrollHeight; return d;
  }
  function bot(t) { return add('bot', t); }
  function me(t) { return add('me', t); }
  function sys(t) { return add('sys', t); }
  function setChips(list) {
    chips.innerHTML = '';
    (list || []).forEach(function (c) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'hybe-mi__chip'; b.textContent = c.label;
      b.addEventListener('click', function () { c.fn ? c.fn() : null; });
      chips.appendChild(b);
    });
  }
  function showQuick() {
    var list = KB.quick.map(function (q) {
      return { label: q.label, fn: function () { me(q.label); if (q.action === 'flow') startFlow(q.id); else answerById(q.id); } };
    });
    list.push({ label: 'Mit dem Team sprechen', fn: function () { me('Mit dem Team sprechen'); startFlow('handoff'); } });
    setChips(list);
  }

  /* ---------- Antworten ---------- */
  function entry(id) { return KB.entries.filter(function (e) { return e.id === id; })[0]; }
  function answerEntry(e) {
    var t = e.a + (e.note ? '\n\n' + e.note : '');
    bot(t);
    if (e.also) { var x = entry(e.also); if (x) bot(x.a + (x.note ? '\n\n' + x.note : '')); }
    if (e.follow) bot(e.follow);
    if (e.flow) { startFlow(e.flow, true); return; }
    showQuick();
  }
  function answerById(id) { var e = entry(id); if (e) answerEntry(e); }
  function norm(s) { return ' ' + String(s).toLowerCase().replace(/\s+/g, ' ') + ' '; }
  function score(kw, text) { var n = 0; kw.forEach(function (k) { if (text.indexOf(k) !== -1) n += k.length > 5 ? 2 : 1; }); return n; }
  function localAnswer(text) {
    var t = norm(text);
    if (score(KB.membership.kw, t) >= 1) return { kind: 'membership' };
    if (score(KB.open_points.kw, t) >= 1) return { kind: 'open' };
    var ranked = KB.entries.map(function (e) { return { e: e, s: score(e.kw, t) }; }).filter(function (x) { return x.s > 0; })
      .sort(function (a, b) { return b.s - a.s; });
    if (!ranked.length) return null;
    return { kind: 'faq', list: ranked.slice(0, ranked.length > 1 && ranked[1].s >= ranked[0].s - 1 ? 2 : 1).map(function (x) { return x.e; }) };
  }

  function userSays(text) {
    text = String(text || '').trim(); if (!text) return;
    me(text);
    if (flow) { flowInput(text); return; }
    if (/^(mensch|mitarbeiter|team|jemand anrufen|echte person)/i.test(text) || /mit (einem )?(menschen|team|mitarbeiter)/i.test(text)) { startFlow('handoff'); return; }
    var r = localAnswer(text);
    if (r && r.kind === 'faq') {
      r.list.forEach(function (e, i) { bot(e.a + (e.note ? '\n\n' + e.note : '')); if (i === r.list.length - 1 && e.follow) bot(e.follow); });
      if (r.list.some(function (e) { return e.flow; })) { startFlow('consult', true); return; }
      showQuick(); return;
    }
    if (r && r.kind === 'open') { bot(KB.open_points.a); offerHandoff(); return; }
    if (r && r.kind === 'membership') { bot(KB.membership.a); showQuick(); return; }
    if (CFG.mode === 'webchat' && CFG.supabase_url && CFG.supabase_key) { askRemote(text); return; }
    bot(KB.fallback); offerHandoff();
  }
  function offerHandoff() {
    setChips([
      { label: 'Ja, Team soll sich melden', fn: function () { me('Ja, Team soll sich melden'); startFlow('handoff'); } },
      { label: 'Andere Frage', fn: function () { me('Andere Frage'); bot('Klar – frag einfach oder wähle ein Thema.'); showQuick(); } }
    ]);
  }
  form.addEventListener('submit', function (e) { e.preventDefault(); var v = input.value; input.value = ''; userSays(v); });

  /* ---------- Freie Fragen über den vorhandenen Michael-Endpunkt (nur Modus "webchat") ---------- */
  var TOKEN_KEY = 'hybe.webchat.brand';
  function rpc(fn, args) {
    return fetch(CFG.supabase_url.replace(/\/+$/, '') + '/rest/v1/rpc/' + fn, {
      method: 'POST', credentials: 'omit',
      headers: { 'Content-Type': 'application/json', apikey: CFG.supabase_key, Authorization: 'Bearer ' + CFG.supabase_key },
      body: JSON.stringify(args)
    }).then(function (r) { if (!r.ok) throw new Error('rpc ' + r.status); return r.json(); });
  }
  function token() {
    var t = null; try { t = localStorage.getItem(TOKEN_KEY); } catch (e) { /* */ }
    if (t) return Promise.resolve(t);
    return rpc('webchat_start_ctx', { p_locale: 'de', p_page: (location.href.split('#')[0] + (CFG.test ? ' [TEST]' : '')).slice(0, 200), p_context: CFG.context })
      .then(function (r) { try { localStorage.setItem(TOKEN_KEY, r.token); } catch (e) { /* */ } return r.token; });
  }
  var seen = {};
  function askRemote(text) {
    var typing = document.createElement('div'); typing.className = 'hybe-mi__typing'; typing.textContent = 'Michael schreibt …'; log.appendChild(typing);
    var tok;
    token().then(function (t) {
      tok = t;
      return rpc('webchat_post', { p_token: t, p_body: text, p_client_msg_id: Date.now().toString(36) + Math.random().toString(36).slice(2, 8), p_intent: null, p_name: null, p_email: null });
    }).then(function (r) {
      if (!r.ai || r.duplicate) return null;
      return fetch(CFG.supabase_url.replace(/\/+$/, '') + '/functions/v1/brand-agent', {
        method: 'POST', credentials: 'omit',
        headers: { 'Content-Type': 'application/json', apikey: CFG.supabase_key, Authorization: 'Bearer ' + CFG.supabase_key },
        body: JSON.stringify({ action: 'turn', message_id: r.message_id, webchat_token: tok })
      });
    }).then(function () { return rpc('webchat_thread', { p_token: tok, p_after: null }); })
      .then(function (th) {
        typing.remove();
        var got = false;
        (th.messages || []).forEach(function (m) {
          var outbound = m.direction ? m.direction === 'out' : (m.author_kind || m.sender || '') !== 'customer';
          if (!outbound || seen[m.id]) return; seen[m.id] = true;
          if (m.body) { bot(m.body); got = true; }
        });
        if (!got) { bot(KB.fallback); offerHandoff(); } else showQuick();
      })
      .catch(function () { typing.remove(); bot(KB.fallback); offerHandoff(); });
  }

  /* ---------- Geführte Anfrage ---------- */
  var flow = null;
  var PKG = [
    { v: 'brand_session', l: 'BRAND SESSION – 1 Event' },
    { v: 'brand_series', l: 'BRAND SERIES – 3 Events' },
    { v: 'community_partnership', l: 'COMMUNITY PARTNERSHIP – 5 Events' },
    { v: 'undecided', l: 'Noch offen' }
  ];
  var CH = [{ v: 'email', l: 'E-Mail' }, { v: 'phone', l: 'Telefon' }, { v: 'whatsapp', l: 'WhatsApp' }];
  var STEPS = {
    consult: ['company', 'product', 'goal', 'package', 'period', 'name', 'channel', 'contact'],
    handoff: ['company', 'name', 'channel', 'contact']
  };
  var ASK = {
    company: 'Wie heißt dein Unternehmen oder deine Marke?',
    product: 'Welches Produkt oder Thema möchtest du vorstellen?',
    goal: 'Was soll das Event für deine Marke erreichen? (z. B. Produkt testen lassen, Marke bekannt machen, Kontakte gewinnen)',
    package: 'Welches Paket interessiert dich?',
    period: 'Hast du einen Wunschzeitraum? (sonst einfach „Überspringen“)',
    name: 'Wie heißt du? (Vor- und Nachname)',
    channel: 'Wie sollen wir dich am liebsten kontaktieren?',
    contact: null
  };
  function startFlow(kind, afterAnswer) {
    flow = { kind: kind, i: 0, d: {} };
    if (kind === 'handoff') bot('Gern bringe ich dich mit unserem Team zusammen. Dafür brauche ich nur ein paar Angaben. Deine Daten nutzen wir ausschließlich für diese Anfrage.');
    else if (!afterAnswer) bot('Super, dann frage ich kurz ein paar Punkte ab. Deine Daten nutzen wir ausschließlich für diese Anfrage.');
    else bot('Ich frage kurz ein paar Punkte ab – deine Daten nutzen wir ausschließlich für diese Anfrage.');
    askStep();
  }
  function stepName() { return STEPS[flow.kind][flow.i]; }
  function askStep() {
    var st = stepName();
    if (!st) return summary();
    var cancel = { label: 'Abbrechen', fn: function () { me('Abbrechen'); flow = null; bot('Alles klar, ich habe nichts gespeichert. Frag mich gern weiter.'); showQuick(); } };
    if (st === 'package') {
      bot(ASK.package);
      setChips(PKG.map(function (p) { return { label: p.l, fn: function () { me(p.l); flowInput(p.v, true); } }; }).concat([cancel]));
    } else if (st === 'channel') {
      bot(ASK.channel);
      setChips(CH.map(function (c) { return { label: c.l, fn: function () { me(c.l); flowInput(c.v, true); } }; }).concat([cancel]));
    } else if (st === 'contact') {
      bot(flow.d.channel === 'email' ? 'Unter welcher E-Mail-Adresse erreichen wir dich?' : 'Unter welcher Nummer erreichen wir dich?');
      setChips([cancel]);
    } else if (st === 'period') {
      bot(ASK.period);
      setChips([{ label: 'Überspringen', fn: function () { me('Überspringen'); flowInput('', true); } }, cancel]);
    } else { bot(ASK[st]); setChips([cancel]); }
    input.focus();
  }
  function flowInput(text, fromChip) {
    var st = stepName(); var v = String(text || '').trim();
    if (st === 'package' && !fromChip) {
      var m = PKG.filter(function (p) { return norm(p.l).indexOf(norm(v).trim()) !== -1 || /session|1 event|eins/i.test(v) && p.v === 'brand_session' || /series|3|drei/i.test(v) && p.v === 'brand_series' || /partner|5|fünf/i.test(v) && p.v === 'community_partnership'; })[0];
      v = m ? m.v : 'undecided';
    }
    if (st === 'channel' && !fromChip) { v = /mail/i.test(v) ? 'email' : /whats/i.test(v) ? 'whatsapp' : /tel|anruf|phone/i.test(v) ? 'phone' : ''; if (!v) { bot('Bitte wähle E-Mail, Telefon oder WhatsApp.'); return; } }
    if (st === 'contact') {
      if (flow.d.channel === 'email' && !H().isEmail(v)) { bot('Das sieht nicht nach einer gültigen E-Mail-Adresse aus. Magst du sie noch einmal eingeben?'); return; }
      if (flow.d.channel !== 'email' && !H().isPhone(v)) { bot('Bitte gib eine Telefonnummer mit Vorwahl ein, z. B. 0211 …'); return; }
    }
    if ((st === 'company' || st === 'name' || st === 'product' || st === 'goal') && v.length < 2) { bot('Magst du das noch kurz ergänzen?'); return; }
    flow.d[st] = v; flow.i++; askStep();
  }
  function label(list, v) { var x = list.filter(function (p) { return p.v === v; })[0]; return x ? x.l : v; }
  function summary() {
    var d = flow.d;
    var lines = ['Unternehmen: ' + d.company];
    if (d.product) lines.push('Produkt: ' + d.product);
    if (d.goal) lines.push('Ziel: ' + d.goal);
    if (d.package) lines.push('Paket: ' + label(PKG, d.package));
    if (flow.kind === 'consult') lines.push('Wunschzeitraum: ' + (d.period || '–'));
    lines.push('Name: ' + d.name);
    lines.push('Kontakt: ' + label(CH, d.channel) + ' – ' + d.contact);
    if (flow.kind === 'consult') lines.push('Wunsch: unverbindliches Beratungsgespräch (Termin wird separat bestätigt)');
    bot('Kurz zusammengefasst:\n' + lines.join('\n') + '\n\nSoll ich das so an unser Team senden?');
    setChips([
      { label: 'Ja, absenden', fn: function () { me('Ja, absenden'); submit(); } },
      { label: 'Etwas ändern', fn: function () { me('Etwas ändern'); var k = flow.kind; startFlow(k, true); } },
      { label: 'Abbrechen', fn: function () { me('Abbrechen'); flow = null; bot('Alles klar, ich habe nichts gespeichert.'); showQuick(); } }
    ]);
  }
  function submit() {
    var d = flow.d, kind = flow.kind;
    var parts = String(d.name).split(/\s+/);
    var hy = H();
    if (!hy.buildInquiry || !hy.post) { bot('Das Senden funktioniert hier gerade nicht – deine Anfrage ist noch nicht gespeichert. Schreib uns gern an post@hyrayse.com.'); flow = null; showQuick(); return; }
    var payload = hy.buildInquiry({
      company: d.company, first_name: parts.shift(), last_name: parts.join(' ') || null,
      email: d.channel === 'email' ? d.contact : null, phone: d.channel !== 'email' ? d.contact : null, preferred_channel: d.channel,
      package: d.package || 'undecided', period: d.period || null, product: d.product || null, goal: d.goal || null,
      message: [d.product ? 'Produkt: ' + d.product : '', d.goal ? 'Ziel: ' + d.goal : ''].filter(Boolean).join(' | ') || 'Kontaktwunsch über Michael',
      consult: kind === 'consult', handoff: kind === 'handoff', slots: []
    }, 'michael_widget');
    setChips([]);
    var typing = document.createElement('div'); typing.className = 'hybe-mi__typing'; typing.textContent = 'Wird gesendet …'; log.appendChild(typing);
    hy.post(hy.inquiryCfg || {}, payload).then(function (r) {
      typing.remove();
      if (!r.ok) {
        bot('Das hat leider nicht geklappt – deine Anfrage ist noch nicht gespeichert. Versuch es gleich noch einmal oder schreib uns an post@hyrayse.com.');
        setChips([{ label: 'Erneut senden', fn: function () { me('Erneut senden'); submit(); } },
                  { label: 'Abbrechen', fn: function () { me('Abbrechen'); flow = null; showQuick(); } }]);
        return;
      }
      var ref = r.data && r.data.reference;
      bot('Danke! Deine Anfrage ist bei uns gespeichert' + (ref ? ' (Referenz ' + ref + ')' : '') + '. Unser Team meldet sich per ' + label(CH, d.channel) + ' bei dir.' +
        (kind === 'consult' ? ' Einen Termin für das Beratungsgespräch schlagen wir dir dann vor – er ist erst mit unserer Bestätigung fest.' : ''));
      hy.track('brand_inquiry_submitted', { package: payload.package, consult_requested: kind === 'consult', source: 'michael', test: !!payload.test });
      if (kind === 'consult') hy.track('brand_consult_requested', { source: 'michael', test: !!payload.test });
      flow = null; showQuick();
    });
  }
})();
